import {
  faDownload,
  faShareNodes,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useReducer, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserComment from "./UserComment";
import CommentSection from "./CommentSection";
import { downloadCertificate } from "../../../utils/generateCertificate";
import { getUserEngagement, toggleLikeCount } from "../../../redux/actions/certificateVerification";
import { SET_USER_ENGAGEMENT_DATA } from "../../../redux/actions/types";
import { use } from "react";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import './index.css'

const UserEngagement = ({openLinkedInLogin}) => {
  const certificateData = useSelector(
    (store) => store?.certificateVerification?.certificateData
  );
  const isCertified =
    certificateData?.certificate_type === "certified" ? true : false;
  const engagements = useSelector(
    (store) => store?.certificateVerification?.engagements
  );
  const commentRef = useRef(null);
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
  const dispatch = useDispatch();
  const isLocked = useSelector((store)=>store?.certificateVerification?.is_locked);

   const variant = useSelector((store)=> store?.certificateVerification?.userType);
  function handleLikeToggle(){
    if(variant === "owner"){
    Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_LIKE_BUTTON_CLICKED);
    }
    else if(variant === "recruiter"){
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_LIKE_BUTTON_CLICKED);
    }
    else{
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_LIKE_BUTTON_CLICKED);
    }
    dispatch(toggleLikeCount(userDetails?.email, certificateData?.unique_certificate_id , (successObj)=>{
       dispatch(getUserEngagement(certificateData?.unique_certificate_id,userDetails?.id,  (successObj)=>{
                 const engagementData = successObj?.data;
            
            const comments = engagementData?.comments || [];
            
            // Find last occurrence from original array
            const matchIndexFromEnd = [...comments].reverse().findIndex(
              item => item?.certificate_verification_users_id && userDetails?.id && item?.certificate_verification_users_id === userDetails?.data?.id
            );
            
            // Convert reversed index to original index
            const matchIndex =
              matchIndexFromEnd !== -1 ? comments.length - 1 - matchIndexFromEnd : -1;
            
            let reorderedComments = [];
            console.log('log2' , matchIndexFromEnd , matchIndex)
            if (matchIndexFromEnd !== -1) {
              let matchedItem = comments[matchIndex];
              matchedItem = {
                ...matchedItem,
                user_name: matchedItem?.['user_name'] + ' (You)'
              };
            
              const remaining = [
                ...comments.slice(0, matchIndex),
                ...comments.slice(matchIndex + 1)
              ];
            
              reorderedComments = [matchedItem, ...remaining];
            } else {
              reorderedComments = comments;
            }
            
            dispatch({
              type: SET_USER_ENGAGEMENT_DATA,
              payload: { ...engagementData, comments: reorderedComments }
            });
            
            
            },(errorObj)=>{}))
    } , (errorObj)=>{}));
  }
  return (
    <div className="flex w-full flex-col justify-start ">
      <div className="flex w-full items-center justify-between">
        <div className="text-[14px] md:text-[16px] font-medium text-[#70AEFF]">
          {certificateData?.name?.split(" ")[0]}’s Assessment Certificate
        </div>
        <img
          alt=""
          src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Frame%20427321276.png?updatedAt=1750399065972"
          className="w-[71px]"
        />
      </div>
      <div className="mt-2 w-full text-left text-[24px] md:text-[28px] font-medium leading-[130%] text-white">
        {certificateData?.certificate_name}
      </div>

      <div
        className="mt-2 w-full rounded-2xl p-[1px]"
        style={{ background: `rgba(66, 133, 244, 0.15)` }}
      >
        <div
          className=" rounded-2xl p-3"
          style={{
            backgroundImage: `radial-gradient(
                                circle, 
                                rgba(43, 189, 19, 0.2) 0%, 
                                rgba(99, 91, 255, 0.2) 81%
                                )`,
          }}
        >
          {isCertified && (
            <div className="flex w-full items-center gap-2">
              <div className="flex flex-1 items-center justify-center gap-1 rounded-lg bg-[#4285F4]/10 py-2 md:py-3 leading-none">
                <img
                  alt=""
                  className=""
                  src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Group%2022267.svg?updatedAt=1750400592828"
                />
                <div className={` ${window.innerWidth <=320 && 'text-[8px]'} text-[10px] md:text-[14px] font-medium text-white/70 `}>
                  Score
                </div>
                <div
                  className={`ml-[3px] ${window.innerWidth <=320 && 'text-[14px]'} text-[18px] md:text-[22px] font-bold text-white`}
                  style={{
                    textShadow: `0px 0px 4.36px rgba(255, 255, 255, 0.3)`,
                  }}
                >
                  {certificateData?.score}%
                </div>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1 rounded-lg bg-[#4285F4]/10 px-5 py-2 md:py-3 leading-none">
                <img
                  alt=""
                  className=""
                  src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Group%2023111.svg?updatedAt=1750401244551"
                />
                <div className={` ${window.innerWidth <=320 && 'text-[8px]'} text-[10px] md:text-[14px] font-medium text-white/70 `}>
                  Rank
                </div>
                <div className="flex items-center justify-center text-[10px] font-normal text-white">
                  <span
                    className={`${window.innerWidth <=320 && 'text-[14px]'}  text-[18px] md:text-[22px] font-bold text-white`}
                    style={{
                      textShadow: `0px 0px 4.36px rgba(255, 255, 255, 0.3)`,
                    }}
                  >
                    {(certificateData?.user_rank + 20000).toLocaleString()}/
                  </span>
                  {(certificateData?.user_rank * 4 + 50000).toLocaleString()}
                </div>
              </div>
            </div>
          )}
          <div className="w-full h-full mx-auto relative">
            <div className="relative">
              <img
                className="mt-2 w-full"
                src={certificateData?.certificate_image_link ? certificateData?.certificate_image_link : 'https://assets.learntube.ai/files/New%20Landing%20Page/Group%2022086.webp?updatedAt=1744894773551'}
                alt="w-full"
                
                style={{ boxShadow: `0px 0px 25px rgba(0, 0, 0, 0.68)` }}
              />
              {variant ==="owner" && <div
                className="absolute top-0 right-0 flex items-center justify-center gap-1 rounded-l-xl rounded-b-xl p-[6px] "
                style={{
                  backgroundImage: `linear-gradient(to right, #4285F4 0%, #020F1D 100%)`,
                }}>
              
                <div className="text-[12px] font-normal text-white ">
                  Shared on
                </div>
                <img
                  src="https://assets.learntube.ai/files/Content_player/LinkdIn.png?updatedAt=1681563676400"
                  alt=""
                  width="16"
                  height="16"
                />
              </div>}
                 {isLocked && <div className='absolute animation-layer-2' />}
            </div>
            
            
          </div>

          <div className="mt-2 w-full flex flex-row items-center justify-between">
            <div className="flex w-[60%] items-center justify-start gap-2">
              <div className="flex items-center justify-start gap-2">
                
                  <div className={`flex items-center justify-center gap-1 rounded-[6px] border-[1px] ${engagements?.is_liked && 'bg-[#4285F4]/40'} border-[#4285F4]/70 p-2 cursor-pointer`} onClick={handleLikeToggle}>
                    <FontAwesomeIcon
                      icon={faThumbsUp}
                      size="md"
                      className={`${engagements?.is_liked ? 'text-[#448BFF]' : 'text-white'}`}
                    />
                    <span className={`text-[12px] text-white font-normal `}>
                      {engagements?.like_count ? engagements?.like_count : 0}
                    </span>
                  </div>
                
                
                  <div className="flex items-center justify-center gap-1 rounded-[6px] border-[1px] border-[#4285F4]/70 p-2 cursor-pointer" onClick={(e)=>{
                    
                    if(variant === "owner"){
                    Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_COMMENT_COUNT_BUTTON_CLICKED); 
                    }
                    else if(variant === "recruiter"){
                      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_COMMENT_COUNT_BUTTON_CLICKED); 
                    }
                    else{
                      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_COMMENT_COUNT_BUTTON_CLICKED); 
                    }
                    
                    
                    commentRef?.current?.focus()} }>
                    <img
                      alt=""
                      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Vector.png?updatedAt=1750403631788"
                      className="w-[16px]"
                    />
                    <span className="text-[12px] font-normal text-white">
                      {engagements?.comment_count ? engagements?.comment_count : 0}
                    </span>
                  </div>
                
              </div>
              {variant === "owner" && <div className="flex items-center justify-center gap-1 rounded-[6px] border-[1px] border-[#4285F4]/70 p-2 cursor-pointer" onClick={(e)=> {
                
                if(variant === "owner"){
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_SHARE_BUTTON_CLICKED);
                }
                else if(variant === "recruiter"){
                  Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_SHARE_BUTTON_CLICKED);
                }
                else{
                  Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_SHARE_BUTTON_CLICKED);  
                }
                
                
                openLinkedInLogin('share')} }>
                <FontAwesomeIcon
                  icon={faShareNodes}
                  size="md"
                  className="text-white"
                />
              </div>}
            </div>
            <div className="flex items-center justify-center gap-1 rounded-[6px] border-[1px] border-[#4285F4]/70 p-2 cursor-pointer" onClick={(e)=> {
              
              if(variant === "owner"){
              Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_DOWNLOAD_BUTTON_CLICKED);
            }else if(variant === "recruiter"){
              Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_DOWNLOAD_BUTTON_CLICKED);
            }
            else{
              Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_DOWNLOAD_BUTTON_CLICKED);
            }
            
            
            downloadCertificate(certificateData?.certificate_image_link) }}>
              <FontAwesomeIcon
                icon={faDownload}
                size="md"
                className="text-white"
              />
            </div>
          </div>
          <div className="mt-3">
            <UserComment commentRef={commentRef}/>
          </div>
          <div className="mt-3">
            <CommentSection />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEngagement;
